import { ReactNode } from 'react';

import { Card, CardBody, Copyright } from '@personly/libs-widgets';

import BrandJumbotron from '@/components/brand-jumbotron';

interface Props {
  children: ReactNode;
  name: string;
}

const ErrorView = ({ children, name }: Props) => (
  <div className="w-full flex sm:container justify-center px-3 mx-auto sm:px-0">
    <div className="w-full sm:w-3/5 lg:w-2/5">
      <Card shadow>
        <CardBody>
          <div className="flex flex-col gap-4">
            <div>
              <BrandJumbotron alt={name} />
            </div>
            <div>{children}</div>
            <div className="flex justify-center">
              <Copyright name={name} />
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  </div>
);

export default ErrorView;
